<template>
  <div id="page-user-list">
   
    <br />
    <vs-card>
      <!-- {{ avaliados }} -->
      <!-- {{ departments }} -->
      <!-- {{ avaliacoes }} -->

      <vs-table search stripe :data="avaliacoes">
        <template slot="header">
        
          <vs-button
            @click="popupAdd = true"
            icon-pack="feather"
            icon="icon-plus"
            color="primary"
            type="border"
            class="mb-2"
            style="white-space: nowrap;"
            >Nova avaliação</vs-button
          >
       
        </template>
        <template slot="header">
          <vs-row>
            <div class="link">
              <!--Link for report-->
              <!-- <a href="http:\/\/connecthr-files.s3.amazonaws.com\/Connect Plus\/assessment_performance"
                    target="_blank">Ver relatorio</a> -->
              <!-- <a href="https:\/\/connecthr-files.s3.amazonaws.com\/1"  target="_blank">Ver relatorio</a> -->
            </div>
          </vs-row>
        </template>

        <template slot="thead">
          <vs-th sort-key="name">Departamento</vs-th>
          <vs-th sort-key="surname">Data de inicio</vs-th>
          <vs-th sort-key="surname">Data de termino</vs-th>
          <!-- <vs-th sort-key="surname">Estado</vs-th> -->
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td>
              {{ data[indextr].employee_name }}
              {{ data[indextr].employee_surname }}
            </vs-td> -->

            <vs-td>{{ data[indextr].department_name }}</vs-td>
            <vs-td>{{ data[indextr].start_date }}</vs-td>
            <vs-td>{{ data[indextr].end_date }}</vs-td>
            <vs-td class="font-bold whitespace-no-wrap">
              <vs-chip v-if="data[indextr].status == 'created'">
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-primary'"
                ></div>
                <span>Submetido</span>
              </vs-chip>
              <vs-chip v-if="data[indextr].status == 'approved'">
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-success'"
                ></div>
                <span>Aprovado</span>
              </vs-chip>
              <vs-chip v-if="data[indextr].status == 'reproved'">
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-warning'"
                ></div>
                <span>Reprovado</span>
              </vs-chip>
              <vs-chip v-if="data[indextr].status == 'canceled'">
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-danger'"
                ></div>
                <span>Cancelado</span>
              </vs-chip>
            </vs-td>
            <vs-td class="whitespace-no-wrap" :data="data[indextr].employee_id">
              <vs-row>
                <!-- {{ }} -->
                <vs-button
                  class="ml-1 mb-1"
                  color="success"
                  size="small"
                  icon-pack="feather"
                  icon="icon-log-in"
                  :to="{
                    name: 'avaliacao-final',
                    params: {
                      periodId: data[indextr].id,
                      departmentId: data[indextr].department_id,
                    },
                  }"
                  >Avaliar</vs-button
                >
              </vs-row>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-3"
        :total="totalPage"
        @change="getData()"
        v-model="currentPage"
      ></vs-pagination>
      <div
        style="height: 50px"
        id="div-with-loading"
        class="vs-con-loading__container"
      ></div>
    </vs-card>
    <vs-popup
      class="holamundo"
      title="Período de Avaliação"
      :active.sync="popupAdd"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Departamento</label> <br />
          <select v-model="selectedDepartmentId" class="custom-select">
            <option
              v-for="department in uniqueDepartmentNames"
              :value="department.id"
            >
              {{ department.name }}
            </option>
          </select>
          <!-- <div v-if="selectedDepartmentId">
              <p>Departamento Selecionado: {{ selectedDepartmentId }}</p>
            </div> -->
        </div>
        <!-- <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Funcionário</label> <br>
          <select v-model="selectedEmployee" class="custom-select">
              <option
                v-for="employee in departmentEmployees"
                :value="employee.id"
              >
                {{ employee.name }}
              </option>
            </select>
        </div> -->
        <!-- <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Critérios</label>
          <vs-input
            class="w-full mt-2 mb-5"
            :options="criterias"
            v-model="selectedCriteria"
            name="criterios"
          />
          <span class="text-danger text-sm" v-show="errors.has('criterios')">{{
            errors.first("criterios")
          }}</span>
        </div> -->
        <!-- <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Período</label>
          <select v-model="selectedPeriod" class="custom-select">
            <option value="jan_jun">Janeiro a Junho</option>
            <option value="jul_dez">Julho a Dezembro</option>
          </select>
        </div>
         -->
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Data de Inicio</label>
          <vs-input class="w-full mt-2 mb-5" type="date" v-model="start_date" />
        </div>
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Data de Termino</label>
          <vs-input class="w-full mt-2 mb-5" type="date" v-model="end_date" />
        </div>

        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button class="ml-auto mt-2" @click="saveData"
              >Adicionar</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              type="border"
              color="warning"
              @click="cancelarPopAdd"
              >Cancelar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import http from "../../../../../http-common";
import { PermissionsMixin } from "../../../../mixins/permissions";
import VxTimeline from "@/components/timeline/VxTimeline.vue";

export default {
  mixins: [PermissionsMixin],
  components: {
    vSelect,
    VxTimeline,
  },
  data() {
    return {
      criterias: [],
      selectedCriteria: [],
      avaliacoes: [],
      name: "",
      description: "",
      type: "",
      totalPage: "",
      currentPage: "1",
      paginate: 15,
      total: "",
      departments: [],
      departmentId: null,
      selectedDepartmentId: null,
      checkBox1: false,
      paperSize: "A3",
      Items: [],
      entrada: [],
      start_date: "",
      end_date: "",
      selectedPeriod: "",
      periods: [],
      amount: "",
      relatorio: "",
      relatorioVer: "",
      employees: [],
      popupAdd: false,
      popupEdit: false,
      popupGerar: false,
      popupReport: false,
      name: "",
      abbreviation: "",
      type: "",
      components: [],
      component: [
        {
          id: "",
          name: "",
          abbreviation: "",
          type: "",
        },
      ],
      folhas: [],
      popupVer: false,
      paperSize: "A3",
      currentUser: [],

      timelineData: [
        {
          color: "primary",
          icon: "PlusIcon",
          title: "New Task Added",
          desc: "Bonbon macaroon jelly beans gummi bears jelly lollipop apple",
          time: "25 Days Ago",
        },
        {
          color: "warning",
          icon: "AlertCircleIcon",
          title: "Task Update Found",
          desc: "Cupcake gummi bears soufflé caramels candy",
          time: "15 Days Ago",
        },
        {
          color: "success",
          icon: "CheckIcon",
          title: "Task Finished",
          desc: "Candy ice cream cake. Halvah gummi bears",
          time: "20 mins ago",
        },
      ],
      fruitCollection: [
        "Horas Extras",
        "Imposto sobre o Rendimento de Pessoas Singulares",
        "Instituto Nacional de Segurança Social",
      ],

      status: "Submited",
      observation: "SIm",
      assessment_period_id: 1,
      user_id: 2,
      avaliados: [],
      relatorio: "",
      report: false,
      relatorioDepartment: "",
    };
  },
  computed: {
    uniqueDepartmentNames() {
      return this.departments.reduce((uniqueDepartments, department) => {
        if (
          !uniqueDepartments.some(
            (item) => item.id === department.department_id
          )
        ) {
          uniqueDepartments.push({
            id: department.department_id,
            name: department.department_name,
          });
        }
        return uniqueDepartments;
      }, []);
    },
  },
  // watch: {
  //   selectedPeriod(value) {
  //     const currentYear = new Date().getFullYear();

  //     const currentMonth = new Date().getMonth() + 1;

  //     if (value === "jan_jun") {
  //       if (currentMonth <= 6) {
  //         this.start_date = `${currentYear - 1}-01-01`;
  //         this.end_date = `${currentYear - 1}-06-30`;
  //       } else {
  //         this.start_date = `${currentYear}-01-01`;
  //         this.end_date = `${currentYear}-06-30`;
  //       }
  //     } else if (value === "jul_dez") {
  //       if (currentMonth <= 6) {
  //         this.start_date = `${currentYear - 1}-07-01`;
  //         this.end_date = `${currentYear - 1}-12-31`;
  //       } else {
  //         this.start_date = `${currentYear}-07-01`;
  //         this.end_date = `${currentYear}-12-31`;
  //       }
  //     }
  //   },
  // },
  mounted() {
    this.initialize();
    
    // this.generateEvaluationPeriodOptions();
  },
  // computed: {
  //   flattenAvaliados() {
  //     const flattened = [];
  //     for (const departmentName in this.avaliados.department) {
  //       const department = this.avaliados.department[departmentName];
  //       flattened.push(...department);
  //     }
  //     return flattened;
  //   },
  // },

  methods: {
    initialize() {
      this.getData();
      this.getColumns();
      this.getAvaliation();
      this.getDepartament();
    },
    // generateEvaluationPeriodOptions() {
    //   const currentYear = new Date().getFullYear();
    //   const currentMonth = new Date().getMonth() + 1; // Adicionamos 1 porque o mês é indexado em 0

    //   this.periods = [];

    //   // Adicione opção para o segundo semestre do ano anterior se estivermos no primeiro semestre deste ano
    //   if (currentMonth >= 1 && currentMonth <= 6) {
    //     this.periods.push({
    //       label: `Janeiro a Junho de ${currentYear - 1}`,
    //       value: `jan_jun_${currentYear - 1}`,
    //     });
    //     this.periods.push({
    //       label: `Julho a Dezembro de ${currentYear - 1}`,
    //       value: `jul_dez_${currentYear - 1}`,
    //     });
    //   }

    //   // Adicione opção para o primeiro semestre do ano corrente se estivermos no segundo semestre deste ano
    //   if (currentMonth >= 7) {
    //     this.periods.push({
    //       label: `Janeiro a Junho de ${currentYear}`,
    //       value: `jan_jun_${currentYear}`,
    //     });
    //   }

    //   // Adicione opção para o segundo semestre do ano corrente
    //   this.periods.push({
    //     label: `Julho a Dezembro de ${currentYear}`,
    //     value: `jul_dez_${currentYear}`,
    //   });

    //   // Defina o período selecionado como a primeira opção disponível
    //   this.selectedPeriod = this.periods[0] ? this.periods[0].value : "";
    // },
    cancelarPopAdd() {
      this.popupAdd = false;
    },
    cancelarPopReport() {
      this.popupReport = false;
    },
    verDetalhes(employee) {
      this.$router.push({
        name: "avaliacao-criterios",
        params: {
          avaliacaoId: employee.employee_id,
        },
      });
    },
    getDepartament() {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/performances/departments", config)
        .then((result) => {
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          this.departments = result.data;
        })
        .catch((error) => {
          error;
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },
    getReport() {
      // this.$vs.loading();
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get(`performances/department_evaluation_pdf`, config)
        .then((result) => {
          this.relatorio = result.data.pdf_url;
          this.report = true;
          this.$vs.loading.close();
        })
        .catch((error) => {
          error;
          this.$vs.loading();
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },
    getAvaliation() {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/performances/weightPerformanceDescription", config)
        .then((result) => {
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          this.avaliados = result.data;
        })
        .catch((error) => {
          error;
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },

    getData() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 1.0,
        type: "sound",
      });
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/performances/assessment_periods", config)
        .then((result) => {
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          this.avaliacoes = result.data.data;
        })
        .catch((error) => {
          error;

          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },

    getVisualizar() {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params: {
          //selectedColumns: this.Items,
          paperSize: this.paperSize,
        },
      };

      http
        .get(`salaries/payroll-entry/${this.entrada.id}`, config)
        .then((result) => {
          this.relatorioVer = result.data;
          (this.down = true), this.$vs.loading.close();
        })
        .catch((error) => {
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });

          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },

    async saveData() {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        department_id: this.selectedDepartmentId,
        start_date: this.start_date,
        end_date: this.end_date,
      };

      http
        .post("/performances/assessment_periods", data, config)
        .then((success) => {
          success;
          (this.popupAdd = false), this.$vs.loading.close();
          this.getAvaliation();
          this.getData();
          this.$vs.notify({
            title: "Sucesso",
            text: "Adicionado com sucesso!",
            color: "success",
            position: "top-right",
          });
          // novoId = success.data.id;
          // this.$router.push({
          //   name: "periodo-avaliacao",
          //   params: {
          //     departmentId: this.selectedDepartmentId,
          //     id: novoId,
          //   },
          // });
          this.date = "";
          this.amount = "";
          this.reason = "";
          this.selectedEmployee = [];
        })
        .catch((error) => {
          error;
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },
    getCriteria() {
      // this.$vs.loading({
      //   container: '#div-with-loading',
      //   scale: 1.0,
      //   type: 'sound'
      // })

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/performances/criterias", config)
        .then((result) => {
          // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.criterias = result.data.data;
          // alert("2")
        })

        .catch((error) => {
          error;
          // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },
    //   getApprovals() {

    //   let token = localStorage.getItem("token");
    //   let config = {
    //     headers: {
    //       authorization: "Bearer " + token,
    //     },
    //   };

    //   http
    //     .get(`performances/assessments_approvals/${this.$route.params.assessmentId}`, data,config)
    //     .then((result) => {
    //       success;
    //       this.comentarios = result.data

    //     })
    //     .catch((error) => {
    //       error;

    //       if(error.response.status==401 ){
    //         this.$router.push('/').catch(() => {})
    //       }

    //     });

    // },
    async saveApprovals() {
      //   this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        status: this.status,
        observation: this.observation,
        // assessment_period_id:this.$route.params.assessmentId,
        assessment_period_id: 1,
        user_id: this.user_id,
      };

      this.$validator.validateAll();
      await http
        .post("performances/assessments_approvals", data, config)
        .then((success) => {
          success;

          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Salvo com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
          if (error.response.status == 422) {
            this.err = error.response.data;
            console.log(this.err);
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              title: "Erro",
              text: "Aconteceu algum erro",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }
        });
    },

    async getColumns() {
      // this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/performances/assessments_approvals", data, config)
        .then((success) => {
          success;
          this.popupReprovar = false;
          this.abbreviation = "";
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizado com sucesso!",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.abbreviation = "";
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },
    getReportDepartment() {
      // alert(2);
      // this.$vs.loading();
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get(
          `performances/department_evaluation_pdfID/${this.selectedDepartmentId}`,
          config
        )
        .then((result) => {
          this.relatorioDepartment = result.data.pdf_url;
          this.$vs.loading.close();
        })
        .catch((error) => {
          error;
          this.$vs.loading();
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },
    // getColumns() {
    //   //  this.$vs.loading()

    //   let token = localStorage.getItem("token");
    //   let config = {
    //     headers: {
    //       authorization: "Bearer " + token,
    //     },
    //   };

    //   http
    //     .get("/salaries/payrollSheet-columns", config)
    //     .then((result) => {
    //       //  this.$vs.loading.close()
    //       this.Items = result.data.Columns;

    //       //  this.Items= this.components.map(col => ({ name: col.name }));
    //     })
    //     .catch((error) => {
    //       error;

    //       if (error.response.status == 401) {
    //         this.$router.push("/").catch(() => {});
    //       }
    //     });
    // },

    // getColumns() {
    //   //  this.$vs.loading()

    //   let token = localStorage.getItem("token");
    //   let config = {
    //     headers: {
    //       authorization: "Bearer " + token,
    //     },
    //   };

    //   http
    //     .get(`/salaries/payroll-entry/`, config)
    //     .then((result) => {
    //       //  this.$vs.loading.close()
    //       this.folha = result.data;

    //       //  this.Items= this.components.map(col => ({ name: col.name }));
    //     })
    //     .catch((error) => {
    //       error;

    //       if (error.response.status == 401) {
    //         this.$router.push("/").catch(() => {});
    //       }
    //     });
    // },

    popupOpenGerar(entrada) {
      (this.entrada = entrada), (this.popupGerar = true);
    },

    async popupOpenVer(entrada) {
      (this.entrada = entrada), await this.getVisualizar();
      this.popupVer = true;
      this.relatorio = "";
    },
    popupOpenEdit(entrada) {
      (this.entrada = entrada), (this.popupEdit = true);
    },

    async editData() {
      //      this.$validator.validateAll().then(result => {
      // if (result) {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        status: this.status,
      };

      this.$validator.validateAll();
      http
        .patch(`/salaries/approvals/${this.entrada.id}`, data, config)
        .then((success) => {
          success;
          (this.popupEdit = false), this.getData(), this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizado com sucesso!",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
      // }})
    },
  },
};
</script>
<style>
.custom-select {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 570px;
}
</style>
